import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataMapperService {

  constructor() { }

  public static mapCustomerToPersonData(loginData, customerAge) {
      let totalAge;
      if (customerAge) {
          totalAge = (new Date().getFullYear()) - (Number(customerAge.split('/')[2].trim()))
      }
    const customer = loginData?.customer ?? {};

    const personData = {
      age: totalAge ?? '',
      dateOfBirth: customer.dateOfBirth
        ? customer.dateOfBirth.replaceAll('/', '-')
        : '',
      gender: customer.gender === 'M' ? 'Male' : customer.gender === 'F' ? 'Female' : '',
      postcode: customer.address?.postcode ?? '',
      email: customer.emailAddress ?? '',
      forename: customer.forename ?? '',
      surname: customer.surname ?? '',
      mobilePhone: customer.mobilePhone ?? '',
      homePhone: customer.homePhone ?? '',
      quoteEmail: customer.internalSoftOptInInd === 'Y'
        ? 'Y'
        : customer.internalSoftOptInInd === 'N'
          ? 'N'
          : '',
      gcdid: customer.partyId ?? '',
      customerId: customer.customerId ?? ''
    };

    return personData;
  }

  public static buildInputParamForKFI(customerDetail: any, quote: any, cmsData: any, isGMP?: string) {
    const recipientName = this.buildRecipientName(customerDetail);
    return {
      addressLine1: customerDetail.address ? customerDetail.address.line1 : '',
      addressLine2: customerDetail.address ? customerDetail.address.line2 : '',
      addressLine3: customerDetail.address ? customerDetail.address.line3 : '',
      addressLine4: customerDetail.address ? customerDetail.address.line4 : '',
      countryCode: customerDetail.address ? customerDetail.address.countryCode : '',
      lifeTimeAllowanceFlag: 'N',
      isSendToTrustee: 'N',
      thirdParty: { partyType: '', address: {} },
      outputMethod: cmsData.localPrint,
      packCode: '',
      packCodeDescription: '',
      padsRefNo: (quote && quote.padsRefNo) ? quote.padsRefNo : '',
      quoteRef: (quote && quote.quoteRefNo) ? quote.quoteRefNo : '',
      postcode: customerDetail.address ? customerDetail.address.postcode : '',
      recipientName,
      isGMP: (quote && quote?.isGMP) ? quote.isGMP : 'N'
    };
  }

 public static buildRecipientName(customerDetail: any) {
    return (customerDetail.title ? customerDetail.title + ' ' : '') +
        (customerDetail.forename ? customerDetail.forename + ' ' : '') +
        (customerDetail.middleName ? customerDetail.middleName + '  ' : '') +
        (customerDetail.surname ? customerDetail.surname : '');
  }

  public static buildLTAObj(input: any, helpers: any = {}) {
    return {
    pensionFund: helpers.isGARCheck
      ? (helpers.isGARCheck(input.garIndicator) ? input.totalFund : input.netAmount)
      : input.totalFund ?? input.netAmount,

    startDate: input.startDate,
    indicative: input.indicative,

    income: helpers.formatIncome
      ? helpers.formatIncome(input)
      : helpers.formatIncomeFn?.(input.paymentFrequency, input.paymentAdvance),

    incomeIncrease: helpers.formatIncomeIncrease
      ? helpers.formatIncomeIncrease(input)
      : helpers.formatIncomeIncreaseFn?.(input.escalationType, input.escalationRate),

    totalTaxFreeCashAmount: input.totalTaxFreeCashAmount ?? 0,

    incomeDependent: input.secondLifePensionPercentage || 0,
    guaranteedTerm: input.guaranteedTerm || 0,

    guarantedPaymentPeriod: helpers.formatGuarantedPaymentPeriod
      ? helpers.formatGuarantedPaymentPeriod(input.guaranteedTerm)
      : helpers.formatGuarantedPaymentPeriodFn?.(input.guaranteedTerm),

    valueProtection: input.vpPercentage,
    valueProtectionAmount: input.vpAmount,

    quoteExpiry: input.quoteExpiry,

    monthlyIncome: input.annualIncome ? input.annualIncome / 12 : 0,
    annualIncome: input.annualIncome || 0,

    padsRefNo: input.padsRefNo,
    paymentFrequency: input.paymentFrequency,
    selectedProduct: input.product,
    fundingSource: input.source,
    quoteRefNo: input.quoteRefNo,

    annuitantPension: input.annuitantPension ?? 0,
    annuitantYearlyPension: input.annuitantYearlyPension ?? 0,

    applicationId: input.applicationId,
    productOptions: input.productOptions ?? null,

    requoteInd: input.requoteInd,
    applyQuoteInd: input.applyQuoteInd,
    garIndicator: input.garIndicator,
    taxFreeCashAmountPercent: input.taxFreeCashAmountPercent,
    vpIndicator: input.vpIndicator
  };
  }
}